import { render, staticRenderFns } from "./driver_comparison.vue?vue&type=template&id=b9b7f3c8&scoped=true&"
import script from "./driver_comparison.vue?vue&type=script&lang=js&"
export * from "./driver_comparison.vue?vue&type=script&lang=js&"
import style0 from "./driver_comparison.vue?vue&type=style&index=0&id=b9b7f3c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9b7f3c8",
  null
  
)

export default component.exports